import { formatDateValue } from "./timezone";

export function formatImage(value) {
  if (value instanceof Object) {
    return {
      src: value.src,
      title: value.title,
      size: value.rawFile.size,
    };
  }
  return value;
}

export const formatDate = (dateString) => formatDateValue(dateString);

export const upperCaseFirstLetter = (words) => {
  return words
    .split(" ")
    .map((w) => w[0].toUpperCase() + w.substr(1))
    .join(" ");
};

export const toSnakeCase = (words) => {
  return words.toLowerCase().replace(/\W/g, "_");
};

export const snakeCaseToNormal = (words) => {
  return words.replace(/[_]/g, " ");
};

// Create our number formatter.
export function toCurrency(withPrefix) {
  const prefix = withPrefix
    ? {
        style: "currency",
        currency: "USD",
      }
    : {};
  const formatter = new Intl.NumberFormat(
    "en-US",
    // "id-ID",
    {
      ...prefix,
      //   currencyDisplay: "code",
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
    }
  );
  return formatter;
}

export const queryObjectToUrl = (qObj, prefix) => {
  const yy = Object.keys(qObj).map((str) => {
    return str + "=" + qObj[str];
  });
  if (yy.length) {
    return (prefix ? prefix : "") + yy.join("&");
  }
  return prefix ? prefix.replace("?", "") : "";
};

export function toCurrencyAccounting(number, maximumFractionDigits = 2) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: maximumFractionDigits,
    currencySign: "accounting",
  })
    .formatToParts(number)
    .filter(
      (x) =>
        x.type !== "currency" &&
        (x.type !== "literal" || x.value.trim().length !== 0)
    )
    .map((x) => {
      switch (x.type) {
        case "group":
          return ".";
        case "decimal":
          return ",";
        default:
          return x.value;
      }
    })
    .join("");
}

export function capitalizeAllWordsUppercaseLast(input) {
  // Split the string by the underscore
  const words = input.split("_");

  // Capitalize the first word (even if it's the only word)
  words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);

  // If there are more than one word, capitalize all except the last one
  for (let i = 1; i < words.length - 1; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }

  // Make the last word uppercase
  if (words.length > 1) {
    words[words.length - 1] = words[words.length - 1].toUpperCase();
  }

  // Join the words with a space and return the result
  return words.join(" ");
}
// module.exports = { formatImage };
